module.exports = __webpack_public_path__ + "img/maplogo.d7fdfbc9.png";